// The Requests page view this browser opens with (Board or Timeline). Kept in localStorage:
// there is no server-side column for it, and it is a per-device convenience anyway.
const KEY = 'afsp.defaultView';

export function getDefaultView() {
  try { return localStorage.getItem(KEY) === 'timeline' ? 'timeline' : 'board'; } catch { return 'board'; }
}

export function setDefaultView(view) {
  try { localStorage.setItem(KEY, view === 'timeline' ? 'timeline' : 'board'); } catch { /* storage unavailable */ }
}
